import {ThunkAction} from 'redux-thunk';
import {IStore} from '../interface';
import {Action} from 'redux';
import {
  getExerciseDialogue,
  getExerciseDone, getExerciseStatistics,
  getExerciseToDo
} from '../pageAsyncActions';
import {clearErrorAction, finishLoadingAction, startLoadingAction} from '../status/actions';
import {
  setExerciseDialogue,
  setExerciseToDo,
  setExerciseDone, setExerciseStatistics
} from './actions';
import {errorHandler} from '../errorHandler';
import {ToastKey} from '../../components/gritx-toast/ToastKeyEnum';
import {
  getExerciseDialogueApi,
  getExerciseDoneApi, getExerciseStatisticsApi,
  getExerciseToDoApi
} from '../api/exercise';

export const loadExerciseToDoAction = (): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getExerciseToDo;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getExerciseToDoApi();

      dispatch(finishLoadingAction(actionKey));
      dispatch(setExerciseToDo(data));
    } catch (e) {
      console.log('loadExerciseToDoAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadExerciseToDoAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const loadExerciseDoneAction = (): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getExerciseDone;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getExerciseDoneApi();

      dispatch(finishLoadingAction(actionKey));
      dispatch(setExerciseDone(data));
    } catch (e) {
      console.log('loadExerciseDoneAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadExerciseDoneAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const loadExerciseDialogueAction = (id: number): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getExerciseDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getExerciseDialogueApi(id);

      dispatch(finishLoadingAction(actionKey));
      dispatch(setExerciseDialogue(data));
    } catch (e) {
      console.log('loadExerciseDialogueAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadExerciseDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const loadExerciseStatisticsAction = (): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getExerciseStatistics;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getExerciseStatisticsApi();

      dispatch(finishLoadingAction(actionKey));
      dispatch(setExerciseStatistics(data));
    } catch (e) {
      console.log('loadExerciseStatisticsAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadExerciseStatisticsAction,
        actionKey,
        error: e
      }));
    }
  }
});
